import React, { useEffect, useState, useCallback, useContext } from "react";
import { useFocusEffect } from '@react-navigation/native';
import { View, StyleSheet, Text } from 'react-native';
//import useStateWithCallback from 'use-state-with-callback'
import { ListItem, ListItemAccount, ListItemSeparator } from "../components/lists";
// import MosaicOfPublications from "../components/MosaicOfPublications";
// import SeedScreen from "./AddSeedScreen";
// import BranchScreen from "./BranchScreen";
// import { MaterialCommunityIcons } from "@expo/vector-icons";
import connectionConfig from "../config/settings";
// import { createStackNavigator } from "@react-navigation/stack";

import { createMaterialTopTabNavigator } from '@react-navigation/material-top-tabs';
//import useAuth from "../auth/useAuth";
import Button from "../components/Button";
import dateNow from "../utility/dateNow";
import configurationPost from "../config/configurationPost";
import routes from "../navigation/routes";
// import MosaicOfSeedsScreen from "./MosaicOfSeedsScreen";
import SlideNavigator from "../navigation/SlideNavigator";
import colors from "../config/colors";
import { TouchableOpacity } from "react-native-gesture-handler";
import AuthContext from "../auth/context";


const Tab = createMaterialTopTabNavigator();

var date = dateNow()
// var followed = 0
// var followers = 0
// const Tab = createBottomTabNavigator();

 function  FoundUserScreen( {navigation, route}) {
  const [statusFollowed, setStatusFollowed] = useState(0) 
  const [existFollowed, setExistFollowed] = useState(false) 
  const [ followed, setFollowed ] =  useState(0)
  const [ followers, setFollowers ] =  useState(0)  
  const { user, setUser } = useContext(AuthContext);
 // const { user, logOut } = useAuth();


    const listing = route.params;
       var rolesNulos = (" ") 
    //debugger
    var userId = listing.item.userId
    var userIdListing = listing.item.userId
    var foundUserChecker = listing.foundUserChecker
    // const [refresh, setRefresh] = useStateWithCallback(0, (refresh) => {

    // })
       var profileUri =  connectionConfig.imageUrl +'/PerfilDeUsuario/'


  useFocusEffect(
    useCallback(() => {
        //debugger
          getFollowedAndFollowers()
          validateFollowed()
    }, [route.params.item.userId])
  );


//---------------------------------------------
//método para seguir al usuario encontrado
//---------------------------------------------       
    const onPressFollow = async () => {
     // debugger

      validateFollowed()
      if(existFollowed ===  true){
        updateStatusExistFollowed()
      }else{

        var post_values = {
          userId : JSON.parse(user).userId , 
          followedId : listing.item.userId ,
          followerId : JSON.parse(user).userId,
          followerStatus : 1,
          datefollower : date,
        }
        configurationPost.body = JSON.stringify(post_values)
        await fetch(connectionConfig.apiUrl+'/fixoUsers/insertFollower/', configurationPost)
        .then(response => response.json())
        .then(response => {
         // debugger
          getFollowedAndFollowers()
          setStatusFollowed(1)
        })
        .catch(err =>{
          console.log('Insert fixo failed :( review internet service /fixoUsers/insertFollower/', err )
        })     
    }
  }  
  
//---------------------------------------------
//método para dejar de seguir un  usuario 
//---------------------------------------------           
    const onPressUnFollow = async () => {
      var post_values = {
        followerStatus : 0,
        userId : JSON.parse(user).userId , 
        followedId : listing.item.userId , 
        datefollower : date,
      }
      configurationPost.body = JSON.stringify(post_values)
      await fetch(connectionConfig.apiUrl+'/fixoUsers/updateFollowedStatus/', configurationPost)
      .then(response => response.json())
      .then(response => {
       // debugger
       getFollowedAndFollowers()
        setStatusFollowed(0)
      })
      .catch(err =>{
        console.log('Failed :( review internet service /fixoUsers/updateFollowedStatus/', err )
      })
    }  

//----------------------------------------
//valida si el usuario ya sigue ese perfil
//----------------------------------------
const validateFollowed = async () => {
      var post_values = {
        //JSON.parse(user).userId
        userId : JSON.parse(user).userId , 
        followedId : listing.item.userId , 
      }
      configurationPost.body = JSON.stringify(post_values)
      await fetch(connectionConfig.apiUrl+'/fixoUsers/SelecValidateStatusFollowed/', configurationPost)
      .then(response => response.json())
      .then(response => {
       // debugger
        if( response.data[0].followerStatus === 1 ){
          setStatusFollowed(1) 
        }
        if(response.data.length != 0){
          setExistFollowed(true)
        }
      })
      .catch(err =>{
        console.log('Failed :( review internet service /fixoUsers/SelecValidateStatusFollowed/', err )
      })
}  
 
//------------------------------------------------
//hace un update al estatus si el usuario ya existe
//-------------------------------------------------
const updateStatusExistFollowed = async () => {
  var post_values = {
    followerStatus : 1,
    userId : JSON.parse(user).userId , 
    followedId : listing.item.userId , 
    datefollower : date,
  }
  configurationPost.body = JSON.stringify(post_values)
  await fetch(connectionConfig.apiUrl+'/fixoUsers/updateFollowedStatus/', configurationPost)
  .then(response => response.json())
  .then(response => {
   // debugger
      getFollowedAndFollowers()
      setStatusFollowed(1) 
  })
  .catch(err =>{
    console.log('Failed :( review internet service /fixoUsers/updateFollowedStatus/', err )
  })
} 

//---------------------------------------------------
//método para ir por el número de segidore y seguidos
//---------------------------------------------------

const getFollowedAndFollowers = async () => {
  // debugger
     var post_values = {
         userId : userId
     }
   configurationPost.body = JSON.stringify(post_values)
   await fetch(connectionConfig.apiUrl+'/fixoUsers/SelectCountFollowers/', configurationPost)
   .then(response => response.json())
   .then(response => {
     //followers = response.data[0].total_siguen_a   
     setFollowers(response.data[0].total_siguen_a)  
     console.log('response.data[0].total_siguen_a -> ', followers )

   })
   .catch(err =>{
   console.log('Failed :( review internet service /fixoUsers/SelectCountFollowers/', err )
   })
   //---------------------busca followers
     var post_values_ = {
       userId : userId
     }
     configurationPost.body = JSON.stringify(post_values_)
     await fetch(connectionConfig.apiUrl+'/fixoUsers/SelectCountFollowed/', configurationPost)
     .then(response => response.json())
     .then(response => {
       //debugger
     //followed = response.data[0].total_siguen_a
     setFollowed(response.data[0].total_siguen_a) 
console.log('response.data[0].total_siguen_a', response.data[0].total_siguen_a)
     })
     .catch(err =>{
     console.log('Failed :( review internet service /fixoUsers/SelectCountFollowed/', err )
     })
 }

//---------------------------------------------------------------
//navega al screen FollowersScreen para mostrar lista de seguidores
//---------------------------------------------------------------  
const onPressFollowers = () => {
      
  navigation.navigate(routes.FOLLOWERS_SCREEN, { userId })
}

//---------------------------------------------------------------
//navega al screen FollowedScreen para mostrar lista de seguidos
//---------------------------------------------------------------  
const onPressFollowed = () => {
      
  navigation.navigate(routes.FOLLOWED_SCREEN, { userIdListing })
}


    return (
    // <AuthContext.Consumer>
    //   {user =>  (
      <>
       <View style={styles.containerM}>
             <ListItem
                image={profileUri + listing.item.userId + '_' + listing.item.userPhoto}
               // titleRol='chat'
                titleFollowers='Followers'           
                onPress={onPressFollowed}
                onPress1={onPressFollowers}
                subTitle= {rolesNulos}
                subTitleFollowers = {followers}
                titleFollowed ='Followed'
                subTitleFollowed = {followed}
                // onPress={() => logOut()}
                title= {listing.item.userName}
              
            />
            <View style={styles.nameEditContainer}>
            <Text style={styles.textName}>             
                {listing.item.userName}
            </Text>
                {/* <Button
                     
                      onPress={onPressUnFollow}
                      title={"chat"}
                      color={"blueFollow"}
                      style={styles.button}
                /> */}
                <TouchableOpacity  style={styles.button}
                                  onPress={ () => {
                                    var item = route.params.item
                                    console.log('mmmm', route.params.item)
                                    navigation.navigate(routes.CHAT, { item })
                                    }} >
                  <Text style={styles.text}>
                    Chat 
                  </Text>
                </TouchableOpacity>
            </View>
            {
            statusFollowed ===  1 ?
                  <Button onPress={onPressUnFollow}
                  title={"Unfollow"}
                  color={"dark"}
                  />
              :
                  <Button onPress={onPressFollow}
                  title={"Follow"}
                  color={"blueFollow"}
                  />     
            }    
            
        </View>  
        <View style={styles.containerS}>
        <SlideNavigator 
                navigation={navigation} 
                userId={userId}
                foundUserChecker={foundUserChecker}
        >
        </SlideNavigator>  
        </View>        
        {/* <View >
            <MosaicOfPublications userId={JSON.parse(user.user).userId}/>
        </View>  */}

      </>
  
    // )}
    // </AuthContext.Consumer >
    );
}

const styles = StyleSheet.create({
    containerM:{
        marginTop:10,
       // alignItems:'center',
        // width:'100%',
        // height:'100%'  
    },
    containerS:{
      justifyContent: 'space-between',
      // alignItems:'center',
      width:'100%',
      height:'80%',  
      flexDirection:'row',
      flex: 1,
    },
    image: {
        width: 70,
        height: 70,
        borderRadius: 35,
        backgroundColor: 'red',
      },
      textName: {
        color: colors.dark,
        fontSize: 18,
        marginLeft: "8%",
      },
      nameEditContainer: {
        width:'60%',
        height:'15%',  
        flexDirection:'row',
        alignItems: 'baseline',
        justifyContent: 'flex-start',
        marginLeft: '9.9%',
        marginTop: '2%'
      },
      button: {
        backgroundColor: colors.chakra4azu,
        borderRadius: 25,
        justifyContent: "center",
        alignItems: "center",
        padding: 5,
       // width: "100%",
        marginRight: "5%",
        marginLeft: "10%",
        //marginVertical: 10,
      },
      text: {
        color: colors.white,
        fontSize: 18,
        //textTransform: "uppercase",
        //fontWeight: "bold",
      },
})

export default FoundUserScreen;